'use client';
import { useState, useEffect } from 'react';
import Link from 'next/link';
import { Cookie } from 'lucide-react';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem('cookie_consent', 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4">
      <div className="max-w-3xl mx-auto bg-bg-surface border border-border rounded-2xl shadow-2xl p-5 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <div className="flex items-start gap-3 flex-1">
          <Cookie size={20} className="text-brand flex-shrink-0 mt-0.5" />
          <p className="text-sm text-text-secondary leading-relaxed">
            Мы используем файлы cookie для корректной работы сервиса. Подробнее —{' '}
            <Link href="/cookies" className="text-brand hover:underline font-medium">
              Политика Cookie
            </Link>
            .
          </p>
        </div>
        <div className="flex gap-2 flex-shrink-0 w-full sm:w-auto">
          <button
            onClick={decline}
            className="flex-1 sm:flex-none px-4 py-2 rounded-xl border border-border-input text-sm text-text-secondary hover:bg-bg-subtle transition-colors font-medium"
          >
            Отклонить
          </button>
          <button
            onClick={accept}
            style={{ background: 'var(--color-brand)', color: '#fff' }}
            className="flex-1 sm:flex-none px-5 py-2 rounded-xl text-sm font-semibold hover:opacity-90 transition-all shadow-sm"
          >
            Принять
          </button>
        </div>
      </div>
    </div>
  );
}
